import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import LessonService from '@/services/LessonService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        createDate: null,
        createUserId: null,
        description: null,
        groupEscortIds: null,
        groupStudentIds: null,
        status: null,
        isEscort: null,
        isInterval: null,
        isDelta: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        createDate: state.createDate,
        createUserId: state.createUserId,
        description: state.description,
        groupEscortIds: state.groupEscortIds,
        groupStudentIds: state.groupStudentIds,
        status: state.status,
        isEscort: state.isEscort,
        isInterval: state.isInterval,
        isDelta: state.isDelta
    }),
};

const mutations = {
    setGroup(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadGroup({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await LessonService.getGroups(course.id, {
            EntityId: data.id,
            PageSize: 1,
            PageNumber: 1
        });
        commit('setGroup', res.data.items[0]);
        return res.data;
    },
    async loadGroupAdmin({ commit }, data) {
        const res = await LessonService.getReportAdmin(data.id);
        commit('setGroup', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
